import { ExcelTemplate } from '../../interfaces';
import * as XLSX from 'xlsx-js-style';
import { getPreparedData } from './mapping';
import { GroupedPortfolioExcelWrapper } from
  'src/app/domain/organization/components/fair-value-and-pp-charts/data-behind-fv-and-pp-charts/data-behind-fv-and-pp-charts.component';
import { fitToColumn } from '../financial-statement/utils';
import { setColumnWidth, withHeaderStyling } from '../../utils';

export class DataBehindFvAndOpCharts implements ExcelTemplate {
  export(data: GroupedPortfolioExcelWrapper): XLSX.WorkBook {
    const book = XLSX.utils.book_new();
    const sheet = this.getSheet(data);
    XLSX.utils.book_append_sheet(book, sheet);
    return book;
  }

  getSheet(data: GroupedPortfolioExcelWrapper): XLSX.WorkSheet {
    const headers = this.getHeaders(data.categoryName);
    const preparedData = getPreparedData(data, headers);
    const sheet = {
      ...XLSX.utils.aoa_to_sheet(preparedData),
      '!cols': fitToColumn(preparedData),
    };
    const whiteSpaceIndex = [5];
    whiteSpaceIndex.forEach((index) => setColumnWidth(sheet, index, 1));
    return withHeaderStyling(sheet);
  }

  private getHeaders(category: string): string[] {
    return [category, 'Investment','Fair value', 'Gain/(loss)', 'MOIC', null, '% of Cost', '% of FV'];
  }
}
